import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import Game from './game-model'
import { CreateGameAsync, DeleteGameAsync, LoadGamesAsync } from './game-thunk'
const initialState: gameSliceState = {
  game: [],
  selected_game: '',
  is_loading_game: false,
  is_creating_game: false,
  is_deleting_game: false,
}
export interface gameSliceState {
  game: Game[]
  selected_game?: string
  is_loading_game: boolean
  is_creating_game: boolean
  is_deleting_game: boolean
}
export const gameSlice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    setSelectedgame: (state, action) => {
      state.selected_game = action.payload
    },
    clearStategame: (state) => {
      state.game = []
      state.is_loading_game = false
      state.is_creating_game = false
      state.is_deleting_game = false
    },
    mergegame: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_game = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.game = merge(state.game, payload) as any
        }
      }
    },

    add_game: (state, action) => {
      if (action.payload) {
        state.game = [...state.game, action.payload]
      }
    },
    set_game: (state, action) => {
      let { key, value, id } = action.payload
      state.game = state.game.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadGamesAsync.pending, (state) => {
      state.is_loading_game = true
    })
    builder.addCase(LoadGamesAsync.fulfilled, (state, action) => {
      state.is_loading_game = false
      if (action.payload) {
        state.game = action.payload
      }
    })
    builder.addCase(LoadGamesAsync.rejected, (state) => {
      state.is_loading_game = false
    })
    builder.addCase(CreateGameAsync.pending, (state) => {
      state.is_creating_game = true
    })
    builder.addCase(CreateGameAsync.fulfilled, (state) => {
      state.is_creating_game = false
    })
    builder.addCase(CreateGameAsync.rejected, (state) => {
      state.is_creating_game = false
    })
    builder.addCase(DeleteGameAsync.pending, (state) => {
      state.is_deleting_game = true
    })
    builder.addCase(DeleteGameAsync.fulfilled, (state, action) => {
      state.is_deleting_game = false
      if (state.game) {
        state.game = state.game.filter((x) => action.payload.id !== x.id)
      }
    })
    builder.addCase(DeleteGameAsync.rejected, (state) => {
      state.is_deleting_game = false
    })
  },
})

export const {
  clearStategame,
  setSelectedgame,
  set_game,
  mergegame,
  add_game,
} = gameSlice.actions

export const get_game =
  (id?: string) =>
  (state: {
    game: {
      game: Game[]
    }
  }): Game | null => {
    let temp = state?.game?.game?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.game?.game[0] || null
  }
export const get_selected_game = (state: {
  game: gameSliceState
}): Game | null => {
  let id = state?.game?.selected_game
  let temp = state?.game?.game?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_game = (state: {
  game: {
    game: Game[]
  }
}): Game[] => {
  let temp = state?.game?.game
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_game_busy = (state: { game: gameSliceState }) => {
  return (
    state?.game.is_deleting_game ||
    state?.game.is_loading_game ||
    state?.game.is_creating_game
  )
}
export const is_deleting_game_busy = (state: { game: gameSliceState }) => {
  return state?.game.is_deleting_game
}
export const is_loading_game_busy = (state: { game: gameSliceState }) => {
  return state?.game.is_loading_game
}
export const is_creating_game_busy = (state: { game: gameSliceState }) => {
  return state?.game.is_creating_game
}

export default gameSlice.reducer
